import { createFileRoute } from "@tanstack/react-router";

import Camera from "~/pages/Camera";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/meq-camera/$")({
  staticData: ROUTE_STATIC.meqCamera,
  component: Camera,
});
